var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUnhide = function SvgUnhide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.34 10a1.66 1.66 0 1 1 3.32 0 1.66 1.66 0 0 1-3.32 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3.36c-2.375 0-4.311 1.05-5.746 2.247C2.821 6.803 1.84 8.185 1.347 8.964l-.02.032c-.097.154-.224.353-.288.633a1.8 1.8 0 0 0 0 .741c.064.28.19.48.288.633l.02.032c.492.778 1.474 2.161 2.907 3.357C5.69 15.589 7.625 16.639 10 16.639s4.311-1.05 5.746-2.247c1.433-1.196 2.415-2.578 2.907-3.357l.02-.032c.097-.154.224-.353.288-.633a1.8 1.8 0 0 0 0-.741 2 2 0 0 0-.288-.633l-.02-.032c-.492-.779-1.474-2.161-2.907-3.357C14.31 4.41 12.375 3.36 10 3.36m0 3.32a3.32 3.32 0 1 0 0 6.64 3.32 3.32 0 0 0 0-6.64",
    clipRule: "evenodd"
  })));
};
export default SvgUnhide;